<script>

    import { toast } from 'bulma-toast'
    import { userStore, usersStore, modalStore } from '../stores'

    import UsersService from '../$services/users.service'

    import Form from '../$components/form.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import ButtonCancel from '../$components/button.cancel.svelte'
    import Button from '../$components/button.svelte'
    import SelectUser from '../$components/select.users.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'

    let loading = false
    let user = null
    let changeAdviser = false

    async function updateUserAdviser() {

        const data = {
            userId: $userStore._id,
            adviserId: user._id
        }

        loading = true
        const resp = await UsersService.updateUserAdviser($userStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        toast({message: 'Asesor actualizado', type: 'is-success'})

        userStore.set(resp.data)
        usersStore.replace(resp.data)
        modalStore.close()
        changeAdviser = false
    }

    function deleteAdviser() {
        user = {}
        updateUserAdviser()
    }

</script>

{#if $userStore.adviser && !changeAdviser}
    <DetailsCard title="Asesor secundario">
        <DetailsFields>
            <DetailsField label="Nombre" value={$userStore.adviser.name || 'Sin información'} />
            <DetailsField label="Correo" value={$userStore.adviser.email || 'Sin información'} mono />
        </DetailsFields>
        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <div class="buttons">
                    <Button on:click={deleteAdviser} text="Quitar asesor secundario" icon="trash" color="primary" />
                    <Button on:click={() => changeAdviser = true} text="Cambiar asesor secundario" icon="edit" color="light" />
                </div>
            </div>
        </div>
    </DetailsCard>
{/if}

{#if changeAdviser || !$userStore.adviser}
    <DetailsCard title="Cambiar asesor secundario">
        <Form on:submit={updateUserAdviser} {loading}>
            <SelectUser bind:user={user} role="adviser" />
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <div class="buttons">
                    <ButtonCancel on:click={() => changeAdviser = false} />
                    <ButtonSave />
                </div>
            </div>
        </Form>
    </DetailsCard>
{/if}